import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/dashboard.css";
import "./assets/css/dashboard-responsive.css";
import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/css/role-permission.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./Layout";

import Protected from "./Protected";
import Dashboard from "./Component/Home/Dashboard";
import Login from "./Component/Login/Login";

import Students from "./Component/Users/Students";
import UserView from "./Component/Users/UserView.js";
import StudentAdd from "./Component/Users/StudentAdd";

import CourseList from "./Component/Course/CourseList";

import Videos from "./Component/Course/Videos";
import VideoAdd from "./Component/Course/VideoAdd";

import CourseCategory from "./Component/Category/CourseCategory";
import CourseCategoryAdd from "./Component/Category/CourseCategoryAdd";
import CourseCategoryEdit from "./Component/Category/CourseCategoryEdit";
import Reviews from "./Component/Reviews/Reviews";
import Instructors from "./Component/Users/Instructors/Instructors";
import InstructorRequest from "./Component/InstructorRequest/InstructorRequest";
import RequestView from "./Component/Users/Instructors/RequestView";
import BlogList from "./Component/Blogs/BlogList";
import BlogAdd from "./Component/Blogs/BlogAdd";
import BlogCategory from "./Component/Blogs/BlogCategory";
import BlogEdit from "./Component/Blogs/BlogEdit";
import BlogCategoryAdd from "./Component/Blogs/BlogCategoryAdd";
import TestimonialList from "./Component/Testimonials/TestimonialList";
import TestimonialAdd from "./Component/Testimonials/TestimonialAdd";
import TestimonialEdit from "./Component/Testimonials/TestimonialEdit";

import MessagesList from "./Component/Contact/MessagesList";
import MessageView from "./Component/Contact/MessageView";

import SubCategoryList from "./Component/Category/SubactegoryList";
import SubcategoryAdd from "./Component/Category/SubcategoryAdd";
import CouponList from "./Component/Coupons/CouponList";
import CouponAdd from "./Component/Coupons/CouponAdd";
import ArshadStudentList from "./Component/Users/ArshadStudentList";

import Loans from "./Component/Banner/Loans.js";
import LoanView from "./Component/Banner/LoanView";

import BannerList from "./Component/Banner/BannerList.js"
import BannerAdd from "./Component/Banner/BannerAdd";
import BannerEdit from "./Component/Banner/BannerEdit";
import BannerView from "./Component/Banner/BannerView";

import CourseForm from "./Component/Course/CourseForm";
import CourseMoreInfo from "./Component/Course/CourseMoreInfo";
import CourseContent from "./Component/Course/CourseContent";
import Finish from "./Component/Course/Finish";

import Settings from "./Component/Settings/Settings";
import CmsList from "./Component/Cms/CmsList";

import LocationList from "./Component/Career/LocationList";
import LocationAdd from "./Component/Career/LocationAdd";
import DepartmentList from "./Component/Career/DepartmentList";
import JobList from "./Component/Career/JobList";
import JobApplications from "./Component/Career/JobApplications";

import InsuranceHistory from "./Component/InsuranceHistory/InsuranceHistory.js";
import InsuranceView from "./Component/InsuranceHistory/InsuranceView.js";

import InvoicePrint from "./Component/Invoice/InvoicePrint";
import CouponEdit from "./Component/Coupons/CouponEdit";
import AddQuestion from "./Question/AddQuestion";
import QuestionList from "./Question/QuestionList";
import TestSeriesList from "./Component/Test/TestseriesList";
import AddTestSeries from "./Component/Test/AddTestSeries";

import AnimalsList from "./Component/Test/AnimalsList.js";
import AddTestPackage from "./Component/Test/AddTestPackage";
import PageNotFound from "./Component/404/PageNotFound";
import NotificationList from "./Component/Notification/NotificationList";
import NotificationAdd from "./Component/Notification/NotificationAdd";
import NotificationEdit from "./Component/Notification/NotificationEdit";
import ViewAnimalDetails from "./Component/Test/ViewAnimalDetails.js";
import EditAnimalDetail from "./Component/Test/EditAnimalDetail.js";

import TestEdit from "./Component/Test/EditTest";
import AssignQuestionList from "./Question/AssignQuestionList";
import TestQuestions from "./Question/TestQuestions";
import EditQuestion from "./Question/EditQuestion";
import SubjectList from "./Component/Subject/SubjectList";
import AddSubject from "./Component/Subject/AddSubject";
import TopicList from "./Component/Topic/TopicList";
import AddTopic from "./Component/Topic/AddTopic";
import EditTopic from "./Component/Topic/EditTopic";
import EditSubject from "./Component/Subject/EditSubject";

import CmsAdd from "./Component/Cms/CmsAdd.js";
import CmsEdit from "./Component/Cms/CmsEdit.js";

import QuestionFeedbackList from "./Question/QuestionFeedbackList.js";
import AllSubcategories from "./Component/Category/AllSubcategories.js";
import PackageTest from "./Component/Test/PackageTest.js";
import EditSubcategory from "./Component/Category/EditSubcategory.js";

import ReportUserList from "./Component/Report_Users/ReportUsersList.js";
import viewReport from "./Component/Report_Users/ViewReport.js";

import NewsList from "./Component/News/NewsList.js";
import ViewFullNews from "./Component/News/ViewFullNews.js";
import AddNews from "./Component/News/AddNews.js";
import NewsEdit from "./Component/News/NewsEdit.js";

import BusinessList from "./Component/Products/BusinessList.js";
import ProductAdd from "./Component/Products/ProductAdd";
import ProductEdit from "./Component/Products/ProductEdit";

import VisitorList from "./Component/RecentVisitor/VisitorsList.js";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="login" element={<Login />} />
          {/* <Route path="/forget-password" element={ <ForgetPassword/>} /> */}
          {/* <Route path="/reset-password" element={ <ResetPassword/>} /> */}

          <Route path="/" element={<Layout />}>
            <Route index element={<Protected Component={Dashboard} />} />
            <Route path="loans" element={<Protected Component={Loans} />} />
            <Route
              path="banners"
              element={<Protected Component={BannerList} />}
            />
            <Route
              path="banner-add"
              element={<Protected Component={BannerAdd} />}
            />
            <Route
              path="banner/edit/:id"
              element={<Protected Component={BannerEdit} />}
            />
            <Route
              path="banner/view/:id"
              element={<Protected Component={BannerView} />}
            />
            <Route
              path="loans/view/:id"
              element={<Protected Component={LoanView} />}
            />
            <Route
              path="users"
              element={<Protected Component={Students} />}
            />
            <Route
              path="user-view/:id"
              element={<Protected Component={UserView} />}
            />
            <Route
              path="student-add"
              element={<Protected Component={StudentAdd} />}
            />
            <Route
              path="instructors"
              element={<Protected Component={Instructors} />}
            />
            <Route
              path="instructor-request"
              element={<Protected Component={InstructorRequest} />}
            />
            <Route
              path="instructor-request/view/:id"
              element={<Protected Component={RequestView} />}
            />

            <Route path="videos" element={<Protected Component={Videos} />} />

            <Route
              path="add-video"
              element={<Protected Component={VideoAdd} />}
            />


            <Route
              path="visitors"
              element={<Protected Component={VisitorList} />}
            />
            
            <Route path="blogs" element={<Protected Component={BlogList} />} />
            <Route
              path="blogs/add"
              element={<Protected Component={BlogAdd} />}
            />
            <Route
              path="blogs/edit/:id"
              element={<Protected Component={BlogEdit} />}
            />
            <Route
              path="blogs/category"
              element={<Protected Component={BlogCategory} />}
            />
            <Route
              path="blogs/category/add"
              element={<Protected Component={BlogCategoryAdd} />}
            />

            <Route
              path="testimonials"
              element={<Protected Component={TestimonialList} />}
            />
            <Route
              path="testimonials/add"
              element={<Protected Component={TestimonialAdd} />}
            />
            <Route
              path="testimonials/edit/:id"
              element={<Protected Component={TestimonialEdit} />}
            />

            <Route
              path="/settings"
              element={<Protected Component={Settings} />}
            />

            <Route
              path="/coupons"
              element={<Protected Component={CouponList} />}
            />
            <Route
              path="/coupons/add"
              element={<Protected Component={CouponAdd} />}
            />
            <Route
              path="/coupons/edit/:id"
              element={<Protected Component={CouponEdit} />}
            />

            <Route
              path="cms"
              element={<Protected Component={CmsList} />}
            />
            <Route
              path="cms/edit/:id"
              element={<Protected Component={CmsEdit} />}
            />
            <Route
              path="cms/add"
              element={<Protected Component={CmsAdd} />}
            />
            <Route
              path="/locations"
              element={<Protected Component={LocationList} />}
            />
            <Route
              path="/location-add"
              element={<Protected Component={LocationAdd} />}
            />

            <Route
              path="/departments"
              element={<Protected Component={DepartmentList} />}
            />
            <Route
              path="/jobs"
              element={<Protected Component={JobList} />}
            />
            <Route
              path="/job-applications"
              element={<Protected Component={JobApplications} />}
            />
            <Route
              path="/coupons"
              element={<Protected Component={CouponList} />}
            />
            <Route
              path="/coupons/add"
              element={<Protected Component={CouponAdd} />}
            />
            <Route
              path="/ "
              element={<Protected Component={ArshadStudentList} />}
            />
            <Route
              path="courses"
              element={<Protected Component={CourseList} />}
            />
            <Route
              path="/courses/add"
              element={<Protected Component={CourseForm} />}
            />
            <Route
              path="/courses/add/:id"
              element={<Protected Component={CourseForm} />}
            />
            <Route
              path="/courses/add/:id/step=2"
              element={<Protected Component={CourseMoreInfo} />}
            />
            <Route
              path="/courses/add/:id/step=3"
              element={<Protected Component={CourseContent} />}
            />
            <Route
              path="/courses/add/:id/step=4"
              element={<Protected Component={Finish} />}
            />

            <Route
              path="/insurance-history"
              element={<Protected Component={InsuranceHistory} />}
            />
            <Route
              path="/insurance-history/view/:id"
              element={<Protected Component={InsuranceView} />}
            />

            {/* JOB SUCCESSS ROUTES NEW */}
            <Route
              path="/questions/create"
              element={<Protected Component={AddQuestion} />}
            />
            <Route
              path="/questions/edit/:id"
              element={<Protected Component={EditQuestion} />}
            />
            <Route
              path="/questions"
              element={<Protected Component={QuestionList} />}
            />
            <Route
              path="test-series/questions/:id"
              element={<Protected Component={TestQuestions} />}
            />
            <Route
              path="test-series/questions/assign/:id"
              element={<Protected Component={AssignQuestionList} />}
            />
            <Route
              path="/questions/assign"
              element={<Protected Component={AssignQuestionList} />}
            />
            <Route
              path="/questions/feedbacks"
              element={<Protected Component={QuestionFeedbackList} />}
            />

            {/* TEST */}
            <Route
              path="/test-series"
              element={<Protected Component={TestSeriesList} />}
            />
            <Route
              path="/test-series/view/:id"
              element={<Protected Component={TestEdit} />}
            />
            <Route
              path="/test-series/create"
              element={<Protected Component={AddTestSeries} />}
            />
            <Route
              path="/test-series/edit/:id"
              element={<Protected Component={TestEdit} />}
            />

            <Route
              path="/matrimonial-list"
              element={<Protected Component={AnimalsList} />}
            />
            <Route
              path="/animals-list/create"
              element={<Protected Component={AddTestPackage} />}
            />
            <Route
              path="/matrimonial-list/view/:id"
              element={<Protected Component={ViewAnimalDetails} />}
            />
            <Route
              path="/animals-list/edit/:id"
              element={<Protected Component={EditAnimalDetail} />}
            />

            <Route
              path="/report-list"
              element={<Protected Component={ReportUserList} />}
            />
            <Route
              path="/report/view/:id"
              element={<Protected Component={viewReport} />}
            />

            <Route
              path="/news-list"
              element={<Protected Component={NewsList} />}
            />
            <Route
              path="/news/add"
              element={<Protected Component={AddNews} />}
            />
            <Route
              path="/news/view/:id"
              element={<Protected Component={ViewFullNews} />}
            />
            <Route
              path="/news/edit/:id"
              element={<Protected Component={NewsEdit} />}
            />



            <Route
              path="/test-packages/test-list/:id"
              element={<Protected Component={PackageTest} />}
            />
            <Route
              path="categories"
              element={<Protected Component={CourseCategory} />}
            />
            <Route
              path="categories/add"
              element={<Protected Component={CourseCategoryAdd} />}
            />
            <Route
              path="categories/edit/:id"
              element={<Protected Component={CourseCategoryEdit} />}
            />
            <Route
              path="/categories/subcategories/:categoryID/create"
              element={<Protected Component={SubcategoryAdd} />}
            />
            <Route
              path="/categories/subcategories/:categoryId"
              element={<Protected Component={SubCategoryList} />}
            />
            <Route
              path="/categories/subcategories/:categoryId/edit/:id"
              element={<Protected Component={EditSubcategory} />}
            />
            <Route
              path="/categories/subcategories"
              element={<Protected Component={AllSubcategories} />}
            />
            <Route path="reviews" element={<Protected Component={Reviews} />} />

            <Route
              path="contact-messages"
              element={<Protected Component={MessagesList} />}
            />
            <Route
              path="contact-messages/view/:id"
              element={<Protected Component={MessageView} />}
            />
            <Route
              path="notifications"
              element={<Protected Component={NotificationList} />}
            />
            <Route
              path="notifications/create"
              element={<Protected Component={NotificationAdd} />}
            />
            <Route
              path="notifications/edit/:id"
              element={<Protected Component={NotificationEdit} />}
            />
            <Route
              path="business"
              element={<Protected Component={BusinessList} />}
            />
            <Route
              path="products/create"
              element={<Protected Component={ProductAdd} />}
            />
            <Route
              path="products/edit/:id"
              element={<Protected Component={ProductEdit} />}
            />
            <Route
              path="subjects"
              element={<Protected Component={SubjectList} />}
            />
            <Route
              path="subjects/add"
              element={<Protected Component={AddSubject} />}
            />
            <Route
              path="subjects/edit/:id"
              element={<Protected Component={EditSubject} />}
            />
            <Route
              path="topics"
              element={<Protected Component={TopicList} />}
            />
            <Route
              path="topics/add"
              element={<Protected Component={AddTopic} />}
            />
            <Route
              path="topics/edit/:id"
              element={<Protected Component={EditTopic} />} 
            />
           

            <Route path="/invoice/:invoiceId" element={<InvoicePrint />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
